import type { RouteObject } from 'react-router';
import { page } from '@/lib/lazy-route';

// Time tracking (Harvest). Owned by the time module.
export const routes: RouteObject[] = [{ path: 'time', lazy: page(() => import('./time-page'), (m) => m.TimePage) }];
export const orgRoutes: RouteObject[] = [{ path: 'time', lazy: page(() => import('./org-time'), (m) => m.OrgTimePage) }]; // P2-3
